import {
  GET_PARAMETROS_LOCAIS_INIT,
  GET_PARAMETROS_LOCAIS_SUCCESS,
  UPDATE_PARAMETROS_LOCAIS_INIT,
  UPDATE_PARAMETROS_LOCAIS_SUCCESS,
  PARAMETROS_LOCAIS_ERROR_MSG,
  CLEAR_PARAMETROS_LOCAIS
} from '../actionTypes';

export const getParametrosLocaisInit = (data) => ({
  type: GET_PARAMETROS_LOCAIS_INIT,
  payload: data
});

export const getParametrosLocaisSuccess = (data) => {
  return {
    type: GET_PARAMETROS_LOCAIS_SUCCESS,
    payload: data
  };
};

export const updateParametrosLocaisInit = (data) => ({
  type: UPDATE_PARAMETROS_LOCAIS_INIT,
  payload: data
});

export const updateParametrosLocaisSuccess = (data) => ({
  type: UPDATE_PARAMETROS_LOCAIS_SUCCESS,
  payload: data
});

export const parametrosLocaisErrorMsg = (data) => ({
  type: PARAMETROS_LOCAIS_ERROR_MSG,
  payload: data
});

export const clearParametrosLocais = (data) => ({
  type: CLEAR_PARAMETROS_LOCAIS,
  payload: data
});
